export const GET_FIBSD_LIST_IN_PROGRESS = "GET_FIBSD_LIST_IN_PROGRESS";
export const GET_FIBSD_LIST_SUCCESS = "GET_FIBSD_LIST_SUCCESS";
export const GET_FIBSD_LIST_FAIL = "GET_FIBSD_LIST_FAIL";
export const GET_FIBSD_IN_PROGRESS = "GET_FIBSD_IN_PROGRESS";
export const GET_FIBSD_SUCCESS = "GET_FIBSD_SUCCESS";
export const GET_FIBSD_FAIL = "GET_FIBSD_FAIL";
export const COMPLETE_FIBSD_IN_PROGRESS = "COMPLETE_FIBSD_IN_PROGRESS";
export const COMPLETE_FIBSD_SUCCESS = "COMPLETE_FIBSD_SUCCESS";
export const COMPLETE_FIBSD_FAIL = "COMPLETE_FIBSD_FAIL";
